/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner } from './UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner';
import {
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON,
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped,
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON,
} from './UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner';

/**
 * 
 * @export
 * @interface UpdateLeadDecisionRequestBidirectionalActionDetailsDetails
 */
export interface UpdateLeadDecisionRequestBidirectionalActionDetailsDetails {
    /**
     * 
     * @type {Array<UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetailsDetails
     */
    selections: Array<UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>;
    /**
     * 
     * @type {Array<UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetailsDetails
     */
    internal_selections?: Array<UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetailsDetails
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetailsDetails
     */
    time?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetailsDetails
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetailsDetails
     */
    internal_message?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetailsDetails
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetailsDetails
     */
    phone_number_extension?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetailsDetails
     */
    checkbox?: boolean;
}

/**
 * Check if a given object implements the UpdateLeadDecisionRequestBidirectionalActionDetailsDetails interface.
 */
export function instanceOfUpdateLeadDecisionRequestBidirectionalActionDetailsDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "selections" in value;

    return isInstance;
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSON(json: any): UpdateLeadDecisionRequestBidirectionalActionDetailsDetails {
    return UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadDecisionRequestBidirectionalActionDetailsDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selections': ((json['selections'] as Array<any>).map(UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON)),
        'internal_selections': !exists(json, 'internal_selections') ? undefined : ((json['internal_selections'] as Array<any>).map(UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON)),
        'date': !exists(json, 'date') ? undefined : json['date'],
        'time': !exists(json, 'time') ? undefined : json['time'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'internal_message': !exists(json, 'internal_message') ? undefined : json['internal_message'],
        'phone_number': !exists(json, 'phone_number') ? undefined : json['phone_number'],
        'phone_number_extension': !exists(json, 'phone_number_extension') ? undefined : json['phone_number_extension'],
        'checkbox': !exists(json, 'checkbox') ? undefined : json['checkbox'],
    };
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsToJSON(value?: UpdateLeadDecisionRequestBidirectionalActionDetailsDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selections': ((value.selections as Array<any>).map(UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON)),
        'internal_selections': value.internal_selections === undefined ? undefined : ((value.internal_selections as Array<any>).map(UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON)),
        'date': value.date,
        'time': value.time,
        'message': value.message,
        'internal_message': value.internal_message,
        'phone_number': value.phone_number,
        'phone_number_extension': value.phone_number_extension,
        'checkbox': value.checkbox,
    };
}

